export default "__VITE_ASSET__CG3F4dmd__"